'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { colors } from '../../theming/themes/colors';
import Accordion from './Accordion';
const Wrapper = styled.div.withConfig({
  displayName: "Faq__Wrapper",
  componentId: "clguww-0"
})(["flex-direction:column;text-align:left;margin:24px 0 24px 0;width:400px;display:", ";h2{font-family:'Avenir Next W02',Helvetica,Arial,sans-serif;font-weight:700;margin-bottom:16px;margin-top:0;display:block;font-size:32px;line-height:normal;text-transform:none;text-align:left;letter-spacing:0;}.back{cursor:pointer;user-select:none;}.back::before{transform:rotate(225deg);border-style:solid;border-color:", ";border-width:2px 2px 0 0;content:' ';display:inline-block;height:7px;position:relative;top:7px;vertical-align:top;width:7px;margin-right:4px;}.underline{display:inline-block;border-bottom:5px solid ", ";}"], props => props.open ? 'flex' : 'none', colors.PRIMARYORANGE, colors.PRIMARYORANGE);

const Faq = ({
  open,
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Wrapper, {
    open: open,
    children: [/*#__PURE__*/_jsx("span", {
      className: "back",
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "faq.buttons.back"
      })
    }), /*#__PURE__*/_jsx("h2", {
      children: /*#__PURE__*/_jsx("div", {
        className: "underline",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.title"
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      itemScope: true,
      itemType: "https://schema.org/FAQPage",
      children: [/*#__PURE__*/_jsx(Accordion, {
        question: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.what.question"
        }),
        answer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "faq.what.answer"
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "faq.what.details.list.title"
            })
          }), /*#__PURE__*/_jsxs("ul", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.what.details.list.item1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.what.details.list.item2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.what.details.list.item3"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.what.details.list.item4"
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Accordion, {
        question: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.how.question"
        }),
        answer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "faq.how.answer"
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "faq.how.details.list.title"
            })
          }), /*#__PURE__*/_jsxs("ol", {
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.how.details.list.item1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.how.details.list.item2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.how.details.list.item3"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "faq.how.details.list.item4"
              })
            })]
          })]
        })
      }), /*#__PURE__*/_jsx(Accordion, {
        question: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.isFree.question"
        }),
        answer: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.isFree.answer"
        })
      }), /*#__PURE__*/_jsx(Accordion, {
        question: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.safe.question"
        }),
        answer: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.safe.answer"
        })
      }), /*#__PURE__*/_jsx(Accordion, {
        question: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "faq.results.question"
        }),
        answer: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "faq.results.answer"
          }), /*#__PURE__*/_jsx("p", {
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "faq.results.details.body",
              options: {
                link1: /*#__PURE__*/_jsx("a", {
                  onClick: e => e.stopPropagation(),
                  rel: "noreferrer noopener",
                  href: "https://academy.hubspot.com/lessons/improving-website-performance",
                  target: "_blank",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "faq.results.details.link1Text"
                  })
                }),
                link2: /*#__PURE__*/_jsx("a", {
                  onClick: e => e.stopPropagation(),
                  rel: "noreferrer noopener",
                  href: "https://academy.hubspot.com/lessons/enhancing-seo-for-a-website",
                  target: "_blank",
                  children: /*#__PURE__*/_jsx(FormattedMessage, {
                    message: "faq.results.details.link2Text"
                  })
                })
              }
            })
          })]
        })
      })]
    })]
  });
};

export default Faq;